import { appEnv, AppEnv } from '@common';

export const isClarityEnabled = (): boolean => {
  return (
    appEnv === AppEnv.Production ||
    appEnv === AppEnv.Preprod ||
    appEnv === AppEnv.Devtest ||
    appEnv === AppEnv.Development
  );
};
